import { RefreshCw, LogOut, ShieldCheck } from "lucide-react";

/** «Email не подтверждён» — временная верификация: аккаунт держится,
 *  пока администратор не подтвердит почту в RCC. Кнопка «Обновить»
 *  перепроверяет статус; «Выйти» — выход. */
export function PendingVerification({
  email,
  onRefresh,
  onLogout,
}: {
  email?: string;
  onRefresh: () => void;
  onLogout: () => void;
}) {
  return (
    <div className="relative flex h-screen bg-surface text-primary font-sans items-center justify-center overflow-hidden">
      <div className="w-full max-w-sm px-6 flex flex-col items-center gap-5 text-center">
        <div className="w-16 h-16 rounded-2xl bg-accent/10 border border-accent/30 flex items-center justify-center">
          <ShieldCheck size={30} className="text-accent" />
        </div>
        <div>
          <h1 className="text-2xl font-serif tracking-tight">
            Ожидание подтверждения
          </h1>
          <p className="mt-3 text-sm text-secondary leading-relaxed">
            Ваш аккаунт {email ? <span className="text-primary">{email}</span> : ""} создан.
            Доступ откроется, когда администратор подтвердит вашу почту.
          </p>
        </div>
        <div className="w-full flex flex-col gap-2 mt-2">
          <button
            onClick={onRefresh}
            className="w-full h-10 rounded-lg bg-accent text-accent-contrast text-sm font-medium flex items-center justify-center gap-2 hover:opacity-90 transition-all"
          >
            <RefreshCw size={15} /> Проверить статус
          </button>
          <button
            onClick={onLogout}
            className="w-full h-10 rounded-lg bg-hoverbg text-secondary text-sm flex items-center justify-center gap-2 hover:bg-hoverbg2 hover:text-primary transition-colors"
          >
            <LogOut size={15} /> Выйти
          </button>
        </div>
      </div>
    </div>
  );
}
